// import React from "react";
// import { useTranslation } from "react-i18next";

// const Header = ({ category }) => {
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     if (typeof item[field] === 'object') {
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   const categoryName = getLocalizedText(category, "name");
//   const categoryDescription = getLocalizedText(category, "description");

//   return (
//     <div className="bg-yellow-500 py-14 md:py-20 flex justify-center items-center">
//       <div className="text-center text-white px-4">
//         <h1 className="text-3xl md:text-4xl font-bold font-philosopher">
//           {categoryName}
//         </h1>

//         {categoryDescription && (
//           <p className="text-sm md:text-lg mt-3 max-w-3xl mx-auto font-poppins opacity-90 leading-relaxed">
//             {categoryDescription}
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Header;




import React from "react";
import { useTranslation } from "react-i18next";

const Header = ({ category }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    if (typeof item[field] === "string") return item[field];
    if (typeof item[field] === "object") {
      return (
        item[field][currentLanguage] ||
        item[field].en ||
        item[field].hi ||
        item[field].es ||
        item[field].zh ||
        ""
      );
    }
    return "";
  };

  const categoryName = getLocalizedText(category, "name");
  const categoryDescription = getLocalizedText(category, "description");
  const categoryImage = category?.imgUrl;

  return (
    <div className="relative w-full min-h-[220px] md:min-h-[320px] overflow-hidden">
      {/* Background image with overlay */}
      {categoryImage ? (
        <>
          <img
            src={categoryImage}
            alt={categoryName}
            className="absolute inset-0 w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
          {/* Dark gradient overlay for readability */}
          {/* <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" /> */}
        </>
      ) : (
        /* Fallback solid bg if no image */
        <div className="absolute inset-0 bg-yellow-500" />
      )}

      {/* Content */}
      <div className="relative z-10 h-full min-h-[220px] md:min-h-[320px] flex items-center px-6 md:px-16">
        <div className="flex flex-col md:flex-row items-center md:items-end gap-6 md:gap-10 w-full">

          {/* Category circular thumbnail */}
          {categoryImage && (
            <div className="flex-shrink-0 w-24 h-24 md:w-36 md:h-36 rounded-full overflow-hidden border-4 border-white/80 shadow-2xl">
              <img
                src={categoryImage}
                alt={categoryName}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.parentElement.style.display = "none";
                }}
              />
            </div>
          )}

          {/* Text */}
          <div className="text-center md:text-left text-white pb-2">
            <p className="text-xs md:text-sm uppercase tracking-widest text-white/70 font-poppins mb-1">
              {t("category") || "Category"}
            </p>
            <h1 className="text-3xl md:text-5xl font-bold font-philosopher leading-tight drop-shadow-md">
              {categoryName}
            </h1>
            {categoryDescription && (
              <p className="text-sm md:text-base mt-3 max-w-2xl font-poppins text-white/85 leading-relaxed line-clamp-3">
                {categoryDescription}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;